import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StsTenant } from '../../../models/sts-tenant.model';
import { StsPortalStatus } from '../../../models/sts-portal-status';
import { StsA360RegServicesService } from '../../../services/sts-a360-reg-services.service';
import { StsNotificationType } from '../../../models/sts-notification-type';
import { ActivatedRoute, Router } from '@angular/router';
import { StsTfaRegServiceService } from '../../../services/sts-tfa-reg-service.service';
import { StsPortalStatusService } from '../../../services/sts-portal-status.service';
import { StsTenantService } from '../../../services/sts-tenant.service';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import { StsUser } from "../../../models/sts-user.model";


@Component({
  selector: 'account-reg-sel-comm-channel',
  templateUrl: './account-reg-sel-comm-channel.component.html',
  styleUrls: ['./account-reg-sel-comm-channel.component.scss']
})
export class AccountRegSelCommChannelComponent implements OnInit {
  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frmComm: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public tfaReference: string;
  communicationChannels: { value: string, text: string }[] = [];
  public id: string;
  message: StsA360NotificationTokenModel;

  constructor(private tfa: StsTfaRegServiceService,
    private regService: StsA360RegServicesService,
    private portalStatusService: StsPortalStatusService,
    private route: ActivatedRoute,
    private tenantService: StsTenantService,
    public fb: FormBuilder,
    private cmsService: StsCmsService,
    private router: Router) {

    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;

      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          this.tfaReference = portalStatus.tfaReference;
        });

    });

    this.frmComm = this.fb.group({
      selComm: new FormControl('',
        {
          validators: [Validators.minLength(2)],
          updateOn: 'submit'
        }
      )
    }, { updateOn: 'submit' });
  }

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
    if(this.message.Phone.length > 0 )
      this.communicationChannels.push({ value: this.message.Phone, text: this.maskPhone(this.message.Phone) });
    if(this.message.PersonalEmail.length > 0 )
      this.communicationChannels.push({ value: this.message.PersonalEmail, text: this.maskEmail(this.message.PersonalEmail) });
    this.frmComm.controls['selComm'].setValue('0');
  }

  public maskPhone(phone: string): string {
    if (phone == undefined || phone.length == 0)
      return "";
    var replaceWith = 'x';
    var masked = phone.replace(/\d(?!\d{0,3}$)/g, replaceWith);
    return masked;
  }

  public maskEmail(email: string): string {
    if (email == undefined || email.length == 0)
      return "";
    var indat = email.indexOf('@');
    if (indat < 2)
      return "";
    var toreplace = email.substr(1, indat - 1);
    if (toreplace.length < 1)
      return "";
    var replaceWith = '';
    for (var i = 0; i < toreplace.length; i++)
      replaceWith = replaceWith + 'x';

    var masked = email.replace(toreplace, replaceWith);
    return masked;
  }

  public triggerValidation(v) {
    this.frmComm.controls['selComm'].updateValueAndValidity();
  }

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  isInvalidChoice(): boolean {
    return this.frmComm.controls['selComm'].invalid &&
      (this.frmComm.controls['selComm'].dirty || this.frmComm.controls['selComm'].touched); //|| this.frmComm.controls['selComm'].value=='0';
  }

  registerUser(): void {
    let n = new StsA360RegStep2UsernamePostModel();
    n.id = this.id;
    n.email = this.message.PersonalEmail;    
    n.username = this.message.UserName;
        
    this.submitter.emit(true);
    this.regService.postStep2Answers(n).subscribe(rs => {
      this.submitter.emit(false);
      if (rs.success) {
        var mode = this.tenantInfo.tfaPreferredMode;
        if (this.message.PreferredChannel) {
          mode = this.message.PreferredChannel
        }

        this.submitter.emit(true);

        let address = this.message.PreferredChannel == 'phone'
          ? this.message.Phone
          : mode === 'personalemail' ? this.message.PersonalEmail : this.message.Email;
          
        this.tfa.sendValidationEmail(mode, address).subscribe(a => {
            this.submitter.emit(false);
            if (a.success) {
              var urlemail = '/account/validate/email/' + n.id;
              this.router.navigateByUrl(urlemail);
            } else {
              if (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail') {
                let e = new StsNotification();
                e.code =  a.stsCode || 'sts-failed-tfa-email';
                e.level = StsNotificationType.Error;
                e.description = 'an error occured while validating your email';
                this.errors = [e];
              }
              else {
                let e = new StsNotification();
                e.code =  a.stsCode || 'sts-failed-tfa-email-phone';
                e.level = StsNotificationType.Error;
                e.description = 'an error occured while validating your phone';
                this.errors = [e];
              }
            }
          });
      } else {
        let e = new StsNotification();
        e.code = rs['sts-code'] || rs.stsCode;
        e.level = StsNotificationType.Error;
        e.description = 'submitted data contains errors';
        this.errors = [e];
      }
    });
  }

  onSubmitCode(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    if (this.frmComm.valid) {
      this.submitter.emit(true);
      this.errors = [];
      if (this.frmComm.controls['selComm'].value.indexOf("@") > 0) {
        this.message.PreferredChannel = this.tenantInfo.tfaPreferredMode;
      }
      else
        this.message.PreferredChannel = "phone";
      this.regService.changeMessage(this.message);
      this.regService.setCommunicationCahnnel(this.id, this.tenantInfo.clientCode, this.frmComm.controls['selComm'].value, this.tfaReference
      ).subscribe(a => {
        this.submitter.emit(false);
        if (a.success) {
          this.registerUser();
        } else {
          let e = new StsNotification();
          e.code = 'sts-communication-channel-invalid-errors';
          e.level = StsNotificationType.Error;
          this.cmsService.getText(e.code).subscribe(res => {
            e.description = res ? res : 'Not a valid selection';
            this.errors = [e];
          });
        }
      });
    } else {
      let e = new StsNotification();
      e.code = 'sts-communication-channel-errors';
      e.level = StsNotificationType.Error;
      this.cmsService.getText(e.code).subscribe(res => {
        e.description = res ? res : 'Communication channel must be selected';
        this.errors = [e];
      });
    }
  }
}
